module.exports = __webpack_public_path__ + "static/horse1-4e9d2f0535dda52a2a7810f1ad1f4ec2.jpg";